import { ROUTES, SETTINGS_ROUTES } from "@/shared/constants/routes";
import ClipboardPenIcon from "@/shared/images/clipboard-pen.svg";
import { Card, CardBody } from "@nextui-org/react";
import { useNavigate } from "react-router-dom";
import { useLoggedInMember } from "@modules/auth/states";
import { getZaniaTeamMemberRoles } from "@modules/team/states";

const ThirdPartyRiskLanding = () => {
  const navigate = useNavigate();
  const member = useLoggedInMember();
  const { isTeamOrgAdmin, isTeamAdmin } = member
    ? getZaniaTeamMemberRoles("", member)
    : { isTeamOrgAdmin: false, isTeamAdmin: false };

  const isAdmin = isTeamOrgAdmin || isTeamAdmin;

  const handleControlSetsClick = () => {
    navigate(`/${ROUTES.SETTINGS}/${SETTINGS_ROUTES.THIRD_PARTY_CONTROL_SETS}`);
  };

  const handleQuestionnairesClick = () => {
    navigate(`/${ROUTES.SETTINGS}/${SETTINGS_ROUTES.THIRD_PARTY_QUESTIONNAIRES}`);
  };

  const handleIntakeFormClick = () => {
    navigate(`/${ROUTES.SETTINGS}/${SETTINGS_ROUTES.INTAKE_FORM}`);
  };

  return (
    <div className="p-6 w-full h-full flex flex-col">
      <div className="mb-6">
        <h4 className="text-sm font-medium leading-5 text-[#171717]">
          Third-Party Risk Agent Settings
        </h4>
      </div>

      <div className="flex flex-wrap gap-4 items-start">
        {/* Control Sets Card - Frame 158 */}
        <Card
          className="cursor-pointer hover:shadow-md transition-shadow rounded-lg border border-[#E4E4E7] overflow-hidden"
          style={{
            background: 'linear-gradient(180deg, #FFFFFF 0%, #FAFAFA 100%)',
            minWidth: '300px',
            maxWidth: '376.33px',
            height: '180px',
            boxSizing: 'border-box',
            flex: '1 1 calc(33.333% - 1rem)',
            order: 2
          }}
          isPressable
          onPress={handleControlSetsClick}
        >
          <CardBody 
            className="flex flex-col items-start overflow-hidden"
            style={{
              padding: '16px',
              gap: '16px',
              height: '100%'
            }}
          >
            {/* Frame 153 - Icon container */}
            <div 
              className="flex flex-row items-center"
              style={{
                padding: '4px 0px',
                gap: '4px',
                width: '40px',
                height: '48px',
                flex: 'none',
                order: 0,
                flexGrow: 0
              }}
            >
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  background: 'linear-gradient(135deg, #FF6496 0%, #812DD6 100%)',
                  WebkitMask: `url("data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/><polyline points="10,2 10,10 13,7 16,10 16,2"/></svg>')}")`,
                  mask: `url("data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H20v20H6.5a2.5 2.5 0 0 1 0-5H20"/><polyline points="10,2 10,10 13,7 16,10 16,2"/></svg>')}")`,
                  WebkitMaskSize: '100% 100%',
                  maskSize: '100% 100%',
                  WebkitMaskRepeat: 'no-repeat',
                  maskRepeat: 'no-repeat',
                  WebkitMaskPosition: 'center',
                  maskPosition: 'center',
                  flex: 'none',
                  order: 0,
                  flexGrow: 0
                }}
              />
            </div>
            
            {/* Frame 5918 - Content container */}
            <div 
              className="flex flex-col items-start self-stretch overflow-hidden"
              style={{
                padding: '0px',
                gap: '4px',
                width: '344.33px',
                // height: '64px',
                flex: 'none',
                order: 1,
                flexGrow: 0
              }}
            >
              {/* Frame 5944 - Title container */}
              <div 
                className="flex flex-row items-start self-stretch"
                style={{
                  padding: '0px',
                  gap: '4px',
                  width: '344.33px',
                  height: '20px',
                  flex: 'none',
                  order: 0
                }}
              >
                <h5 
                  className="font-medium"
                  style={{
                    width: '344.33px',
                    height: '20px',
                    fontFamily: 'Inter',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '20px',
                    color: '#3F3F46',
                    flex: 'none',
                    order: 0,
                    flexGrow: 1
                  }}
                >
                  Control Sets
                </h5>
              </div>
              
              {/* Description */}
              <p 
                className="self-stretch"
                style={{
                  width: '344.33px',
                  height: '54px',
                  fontFamily: 'Inter',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '20px',
                  color: '#71717A',
                  flex: 'none',
                  order: 1,
                  flexGrow: 0
                }}
              >
                  Maintain sets of assessment controls to match the scope and purpose of your evaluation.
                </p>
            </div>
          </CardBody>
        </Card>

        {/* Questionnaires Card - Frame 160 */}
        {isAdmin && (
        <Card
          className="cursor-pointer hover:shadow-md transition-shadow rounded-lg border border-[#E4E4E7] overflow-hidden"
          style={{
            background: 'linear-gradient(180deg, #FFFFFF 0%, #FAFAFA 100%)',
            minWidth: '300px',
            maxWidth: '376.33px',
            height: '180px',
            boxSizing: 'border-box',
            flex: '1 1 calc(33.333% - 1rem)',
            order: 1
          }}
          isPressable
          onPress={handleQuestionnairesClick}
        >
          <CardBody
            className="flex flex-col items-start overflow-hidden"
            style={{
              padding: '16px',
              gap: '16px',
              height: '100%'
            }}
          >
            {/* Frame 153 - Icon container */}
            <div
              className="flex flex-row items-center"
              style={{
                padding: '4px 0px',
                gap: '4px',
                width: '40px',
                height: '48px',
                flex: 'none',
                order: 0,
                flexGrow: 0
              }}
            >
              <div
                style={{
                  width: '40px',
                  minHeight: '40px',
                  background: 'linear-gradient(135deg, #FF6496 0%, #812DD6 100%)',
                  WebkitMask: `url("data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14,2 14,8 20,8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10,9 9,9 8,9"/></svg>')}")`,
                  mask: `url("data:image/svg+xml,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14,2 14,8 20,8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10,9 9,9 8,9"/></svg>')}")`,
                  WebkitMaskSize: '100% 100%',
                  maskSize: '100% 100%',
                  WebkitMaskRepeat: 'no-repeat',
                  maskRepeat: 'no-repeat',
                  WebkitMaskPosition: 'center',
                  maskPosition: 'center',
                  flex: 'none',
                  order: 0,
                  flexGrow: 0
                }}
              />
            </div>

            {/* Frame 5919 - Content container */}
            <div
              className="flex flex-col items-start self-stretch overflow-hidden"
              style={{
                padding: '0px',
                gap: '4px',
                width: '344.33px',
                // height: '64px',
                flex: 'none',
                order: 1,
                flexGrow: 0
              }}
            >
              {/* Frame 5943 - Title container */}
              <div
                className="flex flex-row items-start self-stretch"
                style={{
                  padding: '0px',
                  gap: '4px',
                  width: '344.33px',
                  height: '20px',
                  flex: 'none',
                  order: 0
                }}
              >
                <h5
                  className="font-medium"
                  style={{
                    width: '344.33px',
                    height: '20px',
                    fontFamily: 'Inter',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '20px',
                    color: '#3F3F46',
                    flex: 'none',
                    order: 0,
                    flexGrow: 1
                  }}
                >
                  Questionnaire & Document Sets
                </h5>
              </div>

              {/* Description */}
              <p
                className="self-stretch"
                style={{
                  width: '344.33px',
                  height: '54px',
                  fontFamily: 'Inter',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '20px',
                  color: '#71717A',
                  flex: 'none',
                  order: 1,
                  flexGrow: 0
                }}
              >
                Create and maintain questionnaires for vendor input and define any documentation that will be required from the vendor.
                </p>
            </div>
          </CardBody>
        </Card>
        )}

        {/* Intake Form Card - Frame 161 - Only visible to Admins */}
        {isAdmin && (
        <Card
          className="cursor-pointer hover:shadow-md transition-shadow rounded-lg border border-[#E4E4E7] overflow-hidden"
          style={{
            background: 'linear-gradient(180deg, #FFFFFF 0%, #FAFAFA 100%)',
            minWidth: '300px',
            maxWidth: '376.33px',
            height: '180px',
            boxSizing: 'border-box',
            flex: '1 1 calc(33.333% - 1rem)',
            order: 0
          }}
          isPressable
          onPress={handleIntakeFormClick}
        >
          <CardBody
            className="flex flex-col items-start overflow-hidden"
            style={{
              padding: '16px',
              gap: '16px',
              height: '100%'
            }}
          >
            {/* Frame 153 - Icon container */}
            <div
              className="flex flex-row items-center"
              style={{
                padding: '4px 0px',
                gap: '4px',
                width: '40px',
                height: '48px',
                flex: 'none',
                order: 0,
                flexGrow: 0
              }}
            >
              <img
                src={ClipboardPenIcon}
                alt="Intake Form"
                style={{
                  width: '40px',
                  height: '40px',
                  flex: 'none',
                  order: 0,
                  flexGrow: 0
                }}
              />
            </div>

            {/* Frame 5920 - Content container */}
            <div
              className="flex flex-col items-start self-stretch overflow-hidden"
              style={{
                padding: '0px',
                gap: '4px',
                width: '344.33px',
                // height: '64px',
                flex: 'none',
                order: 1,
                flexGrow: 0
              }}
            >
              {/* Frame 5945 - Title container */}
              <div
                className="flex flex-row items-start self-stretch"
                style={{
                  padding: '0px',
                  gap: '4px',
                  width: '344.33px',
                  height: '20px',
                  flex: 'none',
                  order: 0
                }}
              >
                <h5
                  className="font-medium"
                  style={{
                    width: '344.33px',
                    height: '20px',
                    fontFamily: 'Inter',
                    fontStyle: 'normal',
                    fontWeight: 500,
                    fontSize: '14px',
                    lineHeight: '20px',
                    color: '#3F3F46',
                    flex: 'none',
                    order: 0,
                    flexGrow: 1
                  }}
                >
                  Intake Form
                </h5>
              </div>

              {/* Description */}
              <p
                className="self-stretch"
                style={{
                  width: '344.33px',
                  height: '54px',
                  fontFamily: 'Inter',
                  fontStyle: 'normal',
                  fontWeight: 400,
                  fontSize: '12px',
                  lineHeight: '20px',
                  color: '#71717A',
                  flex: 'none',
                  order: 1,
                  flexGrow: 0
                }}
              >
                  Capture business context about how the vendor is going to be used and integrated.
                </p>
            </div>
          </CardBody>
        </Card>
        )}
      </div>
    </div>
  );
};

export default ThirdPartyRiskLanding;